// ==========================================================================
// Welcome Page - FSP branded splash screen
// Uses FSP data for logo, name, and colors
// Uses React Query for user data
// ==========================================================================

import { backgroundImage, weatherIcon, poweredByAtram } from '@/assets';
import { useUser } from '@/hooks/useUser';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function WelcomePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: user } = useUser();

  // Get FSP branding
  const fsp = user?.fsp;
  const primaryColor = fsp?.primary_color || '#ED974F';
  const fspName = fsp?.name || 'Atram';
  const fspAppIcon = fsp?.appIcon;
  const isAtram = fspName === 'Atram';

  const handleEnter = () => {
    navigate('/onboarding');
  };

  return (
    <div
      className="min-h-screen flex flex-col bg-cover bg-center bg-no-repeat"
      style={
        isAtram
          ? { backgroundImage: `url(${backgroundImage})` }
          : {
              background: `linear-gradient(180deg, ${primaryColor}, ${fsp?.secondary_color || '#c47535'})`,
            }
      }
    >
      {/* Top: Logo */}
      <div className="pt-12 px-6 flex items-center justify-center pb-16 min-h-[86px]">
        {fspAppIcon && (
          <img
            src={fspAppIcon}
            alt={fspName}
            className="w-[54px] h-[54px] rounded-full object-cover border-0 shadow-none mx-auto"
          />
        )}
      </div>

      {/* Center Weather Icon */}
      <div className="flex-1 flex items-center justify-center min-h-0">
        <img
          src={weatherIcon}
          alt="Weather"
          className="w-[140px] h-[140px] object-contain"
        />
      </div>

      {/* Bottom Content */}
      <div className="px-6 pb-6 text-center">
        <h2
          className="text-[28px] font-bold leading-tight text-black"
        >
          {t('welcome.protectWeather')}
        </h2>
        <h2
          className="text-[28px] font-bold leading-tight mb-4 text-black"
        >
          {t('welcome.protectBusiness')}
        </h2>

        <p
          className="text-[16px] leading-relaxed mb-8 text-black/60"
        >
          {t('welcome.description')}
        </p>

        {/* Enter Button */}
        <button
          type="button"
          onClick={handleEnter}
          className="w-11/12 h-[54px] bg-brand-primary text-white text-[16px] font-semibold rounded-2xl mb-6"
        >
          {t('welcome.startNow')}
        </button>

        {/* Powered by Atram */}
        <div className="flex items-center justify-center">
          <img
            src={poweredByAtram}
            alt="Powered by Atram"
            className="h-[30px] object-contain"
          />
        </div>
      </div>
    </div>
  );
}
